// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"617":"72810102","810":"bf1e9254","936":"925b8f4f","983":"4f787211"}[chunkId] + ".chunk.js";
};